import { useAuth } from './useAuth';
import { orgHeader } from '../tenant';

const API = process.env.REACT_APP_API_URL || '';

export function useApi() {
  const { token, logout } = useAuth();

  const request = async (method, path, body) => {
    const opts = {
      method,
      headers: {
        'Content-Type': 'application/json',
        // Contexto público del subdominio. El backend igual ata la org del usuario
        // logueado a su JWT (no a este header) para las acciones autenticadas.
        ...orgHeader(),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    };
    if (body !== undefined) opts.body = JSON.stringify(body);
    const res = await fetch(`${API}${path}`, opts);
    if (res.status === 401) { logout(); throw new Error('Sesión expirada'); }
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || 'Error en la solicitud');
    return data;
  };

  return {
    get: (path) => request('GET', path),
    post: (path, body) => request('POST', path, body),
    put: (path, body) => request('PUT', path, body),
    patch: (path, body) => request('PATCH', path, body),
    del: (path, body) => request('DELETE', path, body),
  };
}
